import API from '../../api/index'
import Vue from 'vue'

// initial state
const state = {
  all: [],
  domviewer: false,
}

// getters
const getters = {
  allMonitors: state => state.all,
//   getMonitor: (state, {id}) => state.all.find(monitor => monitor.ID === id)
  getMonitor (state) {
    console.log('getters.getMonitor')
    return id => state.all.find(monitor => monitor.id === id) 
  },
  getDOMViewerRequest (state) {
    console.log('getters.getDOMViewerRequest')
    return state.domviewer
  }
}

// actions
const actions = {
  async save({commit}, _monitor) {
    return API.monitors.Save(_monitor)
  },
  async getAllMonitors ({ commit }) {
    API.monitors.getAll().then((monitors) => {
      commit('SET_MONITORS', monitors)
    })
  },
  updateMonitor({state, commit}, monitor) {
      commit('UPDATE_MONITOR', monitor)
  },
  getMonitor ({commit}, {id}) {
    API.monitors.findByID(id).then((monitor) => {
      console.log('actions.getMonitor', monitor)
      commit('UPDATE_MONITOR', monitor)
    })
  }
}

// mutations
const mutations = {
  // this updates the initial store with monitors
  SET_MONITORS(state, monitors) {
    console.log('mutations.SET_MONITORS', monitors)
    state.all = monitors
  },

  ADD_MONITOR(state, monitor) {
    console.log('mutations.ADD_MONITOR', monitor)
    state.all.push(monitor)
  },

  // set and update the monitor? or only set
  UPDATE_MONITOR(state, _monitor) {
    console.log("mutations.UPDATE_MONITOR", _monitor);

    let index = -1;

    index = state.all.findIndex(t => t.id === _monitor.id);
    // console.log(id, key);
    Vue.set(state.all, index, _monitor)
  },
  SET_DOM_VIEWER_REQUEST(state, request) {
    console.log('mutations.DOM_VIEWER_REQUEST', request)
    state.domviewer = request
  },
  CLEAR_DOM_VIEWER_REQUEST(state) {
    console.log('CLEAR_DOM_VIEWER_REQUEST')
    state.domviewer = false
  },

//   decrementProductInventory (state, { id }) {
//     const product = state.all.find(product => product.id === id)
//     product.inventory--
//   }
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/monitors.js